import {formatCurrency, formatDate} from "../../utils/helpers";
import React from "react";

/** @import {Account} from "../../contexts/CustomerDataProviderTypes" */

export const CurrentTermDetailsBox = (/** @type {{maturingAccount: Account | undefined}} */ props) => {
    return <div
        className="text__navy maturity3__info-box maturity3__info-box--wrap">
        <div className={"maturity3__info-box__group maturity3__no-border"}>
            <div className="maturity3__info-box__data-wrapper maturity3__info-box__data-wrapper--wrap maturity3__no-border">
                <p>
                    <b>Your current {props.maturingAccount?.product.name}</b>
                </p>
            </div>
            <div className="maturity3__info-box__data-wrapper maturity3__info-box__data-wrapper--wrap maturity3__no-border">
                <p data-di-mask>
                    Account number: {props.maturingAccount?.accountNumber}
                </p>
            </div>
        </div>
        <div className={"maturity3__info-box__group maturity3__no-border"}>
            <p className="maturity3__info-box__data-wrapper maturity3__info-box__data-wrapper--wrap maturity3__no-border" data-di-mask>Balance: {props.maturingAccount ? formatCurrency(props.maturingAccount.balance) : ''}</p>
            <p className="maturity3__info-box__data-wrapper maturity3__info-box__data-wrapper--wrap maturity3__no-border"><b>Matures on {props.maturingAccount?.maturity?.maturityDate ? formatDate(props.maturingAccount.maturity.maturityDate) : ''}</b></p>
        </div>
    </div>
}
